exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hideText[data-v-49ffd026]{text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;white-space:normal}.clearfix[data-v-49ffd026]{*zoom:1}.clearfix[data-v-49ffd026]:after{content:\"\";display:block;height:0;clear:both;visibility:hidden}.simSun[data-v-49ffd026]{font-family:SimSun}", ""]);

// exports
